import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { APP_DOMAIN } from '../../models/app-domain.token';

@Component({
  selector: 'metall-rechner-impressum',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './impressum.component.html',
  styleUrls: ['./impressum.component.scss']
})
export class ImpressumComponent {
  private domain = inject(APP_DOMAIN);

  impressumEmail = `impressum@${this.domain}`;
}
